import React, { Component } from 'react';
import { ListItem } from './DashboardListings';
import moment from 'moment';
import _ from 'lodash';
import { colors } from '../../tailwind';
import { Text, ViewBox } from '../common';
import Link from '../../components/Link';

class DashboardListingSummary extends Component {
  render() {
    const { reservations, loading, reservationCount, userId } = this.props;
    if (loading) {
      return <div>Loading...</div>;
    }
    const res1 = datestampReservations(reservations);
    const res2 = _.orderBy(res1, 'date', 'asc');
    const res3 = _.takeWhile(
      res2,
      (itm, idx) => itm.date.isSame(new Date(), 'day') || idx < 6,
    );

    //grab top 3 reservations
    //render list items

    return (
      <ViewBox
        header={'Upcoming Exchanges'}
        loading={loading}
        noPadding
        style={{ width: '100%', maxWidth: '1000px' }}
      >
        {buildListItemsForMonth(res3, userId)}
        <Link to="/reservation/current" className="ml-l mt-m mb-l">
          <Text link>See all reservations</Text>
        </Link>
      </ViewBox>
    );
  }
}

export function buildListItemsForMonth(reservations, userId) {
  const grouped = _.groupBy(
    reservations,
    x => x.date.month() + ' ' + x.date.year(),
  );
  const ordered = _.sortBy(
    Object.keys(grouped),
    x => moment(new Date()).diff(x),
    'asc',
  );
  const Items = _.map(ordered, date => {
    const dayArray = grouped[date];
    const itemDate = dayArray[0].date;
    const cal = moment(itemDate).calendar();
    const dateStr =
      cal === 'Today' || cal === 'Tomorrow'
        ? `${cal}, ${moment(itemDate).format('MMMM YYYY')}`
        : moment(itemDate).format('MMMM YYYY');
    return (
      <div>
        <div className="g g-tc-1a1 g-g-m f-align-center my-m px-mxx">
          <div className="h-1 b-0 bb-1 b-cool-gray-light" />
          <Text sectionheader>{dateStr}</Text>
          <div className="h-1 b-0 bb-1 b-cool-gray-light" />
        </div>
        {dayArray &&
          dayArray.map(x => <ListItem item={x} month userId={userId} />)}
      </div>
    );
  });
  return Items;
}

export function datestampReservations(reservations) {
  const matchingStartDates = reservations
    .map(x => {
      const y = { ...x };
      y.isPickup = true;
      y.date = moment(y.checkIn);
      y.time = y.checkInTime.pickupTime;
      if (y.date.isBefore(moment(), 'day')) return null;
      return y;
    })
    .filter(x => x);
  const matchingEndDates = reservations
    .map(x => {
      const y = { ...x };
      y.isPickup = false;
      y.date = moment(y.checkOut);
      y.time = y.checkOutTime.returnTime;
      if (y.date.isBefore(moment(), 'day')) return null;
      return y;
    })
    .filter(x => x);

  return [...matchingStartDates, ...matchingEndDates];
}

export default DashboardListingSummary;



// WEBPACK FOOTER //
// ./src/components_new/dashboard/DashboardListingSummary.js